<template>
    <div v-if="!rowPinned">
        <div v-if="lastError" class="truncate-error">
            <a href="javascript:void(0);" @click="$bvModal.show(lastErrorModalId)">{{ lastError }}</a>
        </div>
        <div v-else>N/A</div>
    </div>
    <div v-else></div>
    
    <modal
        :id="lastErrorModalId"
        title="Last Sync Error"
        ok-title="OK"
        ok-only
        size="lg"
    >
        <p class="mb-2" v-for="(line, index) in formattedLastErrorLines" :key="index">{{ line }}</p>
    </modal>
</template>

<script>
import Modal from '../generic/modal/modal.vue';

export default {
    components: {
        Modal,
    },
    data() {
        return {};
    },
    computed: {
        rowPinned() {
            return this.params.node.rowPinned;
        },
        lastErrorModalId() {
            return 'last-error-cell-render' + this.params.data.id;
        },
        lastError() {
            return this.params.data.last_error;
        },
        formattedLastErrorLines() {
            if (!this.lastError) return [];
            const lines = this.lastError.split('\n');
            return lines.map((line) => {
                return line.trim().endsWith('.') ? line : line + '.';
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.truncate-error {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.truncate-error a {
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
